module.exports = {
    blog_title:'탭션 블로그',
    blog_desc:'크리에이터들을 위한 유용한 글들과 도움되는 조언들이 가득. 탭션 업데이트 소식과 탭션의 새 소식 및 정보도 공유합니다.',
    written_by: '작성자: ', 
}